export default "__VITE_ASSET__BA$3mCS1__"